import React from 'react';
import { StepWizardChildProps } from 'react-step-wizard';
import styled from 'styled-components';

import { FlexRow, SvgIcon, BaseProps } from '@make-software/cspr-ui';
import { BodyText } from '@block-explorer/ui';

import { ProgressLine } from '../progress-line/progress-line';
import { useTranslation } from 'react-i18next';

const Container = styled('div')(({ theme }) => ({
  paddingTop: 28,
  paddingBottom: 52,
}));

const BackBtnContainer = styled.div(({ theme }) => ({
  position: 'absolute',
  left: 0,
  top: 0,
  cursor: 'pointer',
  margin: '20px 30px',
}));

const SpanWrapper = styled.span(() => ({
  marginLeft: '10px',
}));

export interface TransactionWizardNavigationProps
  extends BaseProps,
    Partial<StepWizardChildProps> {
  stepsNames: string[];
  /**
   * **initialNavigationStep** need to be passed if you want to start from step other than 1
   * Also, it overrides the currentStep prop, because it's not working properly.
   *
   * @ISSUE: https://github.com/jcmcneal/react-step-wizard/issues/67
   */
  initialNavigationStep?: number;
}

export const TransactionWizardNavigation = (
  props: TransactionWizardNavigationProps
) => {
  const {
    stepsNames,
    initialNavigationStep,
    isActive,
    totalSteps,
    firstStep,
    lastStep,
    nextStep,
    previousStep,
    goToStep,
    hashKey,
    currentStep = 1,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const stepsTotalCount = stepsNames.length;

  const stepIndex = initialNavigationStep
    ? initialNavigationStep + (currentStep - initialNavigationStep)
    : currentStep;

  const isFirstStep = stepIndex === initialNavigationStep || stepIndex === 1;
  const isLastStep = stepIndex === stepsTotalCount;
  const prevStepNumber = stepIndex - 1;

  const handleBackClick = () => {
    previousStep && previousStep();
  };

  return (
    <Container {...restProps}>
      {!isFirstStep && !isLastStep && (
        <BackBtnContainer onClick={handleBackClick}>
          <BodyText scale={'sm'} size={1} variation={'blue'}>
            <FlexRow align={'center'}>
              <SvgIcon src="assets/icons/ic-arrow-with-tail.svg" />
              <SpanWrapper>
                {t('Back to step')} {prevStepNumber}
              </SpanWrapper>
            </FlexRow>
          </BodyText>
        </BackBtnContainer>
      )}

      <ProgressLine steps={stepsNames} currentIdx={stepIndex} />
    </Container>
  );
};
